import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import FileText from '../../ui/icons/FileText';
import Newspaper from '../../ui/icons/Newspaper';
import Megaphone from '../../ui/icons/Megaphone';
import Coin from '../../ui/icons/Coin';

export default function Menu(
  {
    menu,
    menuSettings,
    results,
    additionalData,
  }: componentTypes.MenuProps,
) {
  const id = encodeURIComponent(`white-instant-search-menu--${menuSettings.attribute}`)
    .toLowerCase()
    .replace(/\.|%[0-9a-z]{2}/gi, '-');

  const {
    items,
    refine,
    createURL,
  } = menu;

  const { search } = additionalData;

  const { classNames } = menuSettings;

  let totalCount = 0;
  let isRefined = false;
  Object.values(items).forEach((item) => {
    totalCount += item.count;
    if (item.isRefined) isRefined = true;
  });

  if (totalCount === 0 && !isRefined) {
    return null;
  }

  if (results.__isArtificial) {
    return null;
  }

  return (
    <>
      <ul id={id} className={classNames?.list || ''}>
        <li className={`${classNames?.item || ''}`}>
          <a
            href={`${additionalData['baseUrl']}${results.query && `?query=${results.query}`}`}
            className={`${classNames?.link} ${!isRefined ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={(event) => {
              event.preventDefault();
              refine('');
            }}
          >
            <span className={classNames?.label}>{Craft.t(search, 'Show all')}</span>
            <span className={classNames?.count}>{totalCount}</span>
          </a>
        </li>
        {items.map((item) => (
          <li
            key={item.value}
            className={classNames?.item || ''}
          >
            <a
              href={createURL(item.value)}
              className={`${classNames?.link} ${item.isRefined ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
            >
              <span className="w-4 h-4">
                {item.value === 'document' && (
                  <FileText iconClass="w-full fill-current" />
                )}
                {item.value === 'page' && (
                  <Newspaper iconClass="w-full fill-current" />
                )}
                {item.value === 'press' && (
                  <Megaphone iconClass="w-full fill-current" />
                )}
                {item.value === 'investorRelations' && (
                  <Coin iconClass="w-full fill-current" />
                )}
              </span>
              <span className={classNames?.label}>{Craft.t(search, item.label)}</span>
              <span className={classNames?.count}>{item.count}</span>
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}
